import {protectedPage} from '@/utils';

import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import Account from '../views/register/Account.vue'
import AccountCode from '../views/register/AccountCode.vue'
import CreateAccount from '../views/register/CreateAccount.vue'
import Prizes from '../views/prizes/Prizes.vue'
import Faqs from '../views/faqs/Faqs.vue'
import Contact from '@/views/contact/Index';
import LegalInformation from '@/views/LegalInformation';
import App from '@/views/App';
// import Chat from '@/views/chat/Chat';
import Stores from '@/views/Stores';
import Offline from '@/views/Offline';

import Page404 from '../views/404.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/404',
    name: 'Page404',
    component: Page404
  },
  {
    path: '/offline',
    name: 'Offline',
    component: Offline
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    beforeEnter(to, from, next) {
      protectedPage(to, from, next);
    },
  },
  {
    path: '/account-code',
    name: 'AccountCode',
    component: AccountCode,
    beforeEnter(to, from, next) {
      protectedPage(to, from, next);
    },
  },
  {
    path: '/create-account',
    name: 'CreateAccount',
    component: CreateAccount
  },
  {
    path: '/prizes',
    name: 'Prizes',
    component: Prizes
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: Faqs
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/legal-information/:slug',
    name: 'LegalInformation',
    component: LegalInformation
  },
  {
    path: '/stores',
    name: 'Stores',
    component: Stores
  },
  {
    path: '/app',
    name: 'App',
    component: App
  },
  {
    path: '*',
    redirect: '/404'
  },
  // {
  //   path: '/chat',
  //   name: 'Chat',
  //   component: Chat
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
          return savedPosition;
      }
      if (to.hash) {
          return { el: to.hash, behavior: "smooth" };
      } else {

          window.scrollTo(0, 0);
      }
  },
});

export default router
